common.View.create('canvas::canvas.blocks.utils.imageOrVideo.Block', {

	onDOMLoad()
	{
		this.initZoom();
	},

	initZoom()
	{
		// Abort due to canvas in edit mode?
		if(this.element.attr('data-canvas-editable'))
			return;

		// Abort due to not zoomable?
		if(!parseInt(this.element.attr('data-zoomable')))
			return;

		// Init LightGallery
		lightGallery(this.element.find('img').get(0), {
			selector: 'this',
		});
	},

});
